<template>
  <div class="content">
    <NavBar :navBlock="navBlock" :navtitle="navtitle"></NavBar>
    <div class="paddingContent">
      <el-row class="ListMenu">
        <el-col :span="24">
          <el-form
            ref="form"
            class="searchForm"
            style="display:flex;flex-wrap:wrap"
          >
            <span
              class="el-form-item__label"
              style="width: 80px;flex-shrink: 0;"
              >會員查询:</span
            >
            <el-form-item style="width: 100px">
              <el-select
                v-model="searchType"
                placeholder="请选择"
                style="width: 100px !important;"
              >
                <el-option label="會員賬號" value="1"></el-option>
                <el-option label="真實姓名" value="3"></el-option>
                <el-option label="會員暱稱" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" class="searchItem">
              <!-- <el-input
                v-model="account"
                @change="
                  account = account.replace(
                    /[\u4E00-\u9FA5]|[\uFE30-\uFFA0]|[\$%\^&\*\\\/]/g,
                    ''
                  )
                "
              ></el-input> -->
              <el-input v-model="account"></el-input>
            </el-form-item>

            <el-form-item label="类型：" class="searchItem">
              <el-select v-model="blackType" placeholder="請選擇類型">
                <el-option label="全部" value=""></el-option>
                <el-option label="登录黑名单" value="1"></el-option>
                <el-option label="评论黑名单" value="2"></el-option>
                <el-option label="活动黑名单" value="5"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="状态：" class="searchItem">
              <el-select v-model="blackStatus" placeholder="請選擇類型">
                <el-option label="全部" value=""></el-option>
                <el-option label="封禁中" value="1"></el-option>
                <el-option label="已解封" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

      <div class="MenuBtnWrap">
        <div class="MenuBtnWrapLeft">
          <div class="btn" @click="exportOrderExcel()">導出所有黑名單</div>
          <div class="btn" @click="uploadModal">批量上傳黑名單</div>
          <div class="downloadExcel" @click="downloadExcel">下載模板</div>
        </div>

        <div style="display:flex;">
          <div class="btn" @click="search()">查詢</div>
          <div class="btn borderBtn" @click="reset()">重置</div>
        </div>
      </div>
      <div class="tableWrap">
        <el-table height="660px" stripe :data="blackList" style="width:100%;">
          <template slot="empty">
            <div class="no-data-container">
              <img
                src="@/assets/images/common/no_data.png"
                alt="暂无数据"
                :style="{ width: '244px', height: '139px' }"
              />
            </div>
          </template>
          <el-table-column
            v-for="(item, index) in blackListTable"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
          >
            <template slot-scope="scope">
              <div v-if="!scope.row[item.prop] && scope.row[item.prop] !== 0">
                -
              </div>
              <div v-else>{{ scope.row[item.prop] }}</div>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="185">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.blackStatus === 1"
                @click="toEditBlackUser(scope.row.userId, scope.row.reason)"
                type="text"
                :key="scope.row.userId"
                >查看</el-button
              >
              <el-button
                v-if="scope.row.blackStatus === 1"
                @click="
                  removeBlackList(
                    scope.row.userId,
                    scope.row.email,
                    scope.row.nickName
                  )
                "
                type="text"
                >解除黑名單</el-button
              >
              <el-button v-else type="text" disabled :key="scope.row.userId"
                >已解封</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paging-block clearfix">
        <el-pagination
          class="paging fr"
          hide-on-single-page
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog
      title="提示信息"
      :visible.sync="uoloadModal"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
      width="500px"
      center
    >
      <div class="dialog">
        <div>
          <el-upload
            ref="excelUpload"
            :action="this.$GLOBAL.blackExcelPostUrl"
            :with-credentials="true"
            class="upload-demo"
            :headers="{ Authorization: this.$cookie.get('auth') }"
            drag
            :accept="'.xlsx,.xls'"
            :multiple="false"
            :file-list="fileList"
            :on-change="fileChange"
            :on-success="successExcel"
            :on-error="errorExcel"
            :auto-upload="false"
          >
            <img
              src="@/assets/images/common/blacklist_upload.png"
              alt="暂无数据"
              :style="{
                width: '41px',
                height: '41px',
                marginTop: '40px',
                marginBottom: '14px'
              }"
            />
            <div class="el-upload__text">
              將文件拖到此處，或<em>點擊上傳</em>
            </div>
            <div class="el-upload__tip" slot="tip">
              只能上傳單個xlsx/xls文件，並且只根據上傳內容進行更新
            </div>
          </el-upload>
          <div class="btngroup">
            <div
              class="btn borderBtn"
              style="marginRight:112px"
              @click="uoloadModal = false"
            >
              取消
            </div>
            <div class="btn" @click="submitupdate">確認更新</div>
          </div>
        </div>
      </div>
    </el-dialog>
    <DiaMess v-if="dialogVisible"></DiaMess>
  </div>
</template>

<script>
import NavBar from "@/components/navBar";
import DiaMess from "@/components/dialog";
export default {
  data() {
    return {
      navBlock: "會員",
      navtitle: "黑名單",
      blackList: [],
      blackListTable: [
        {
          prop: "email",
          label: "會員賬號",
          width: "200"
        },
        {
          prop: "realName",
          label: "真實姓名",
          width: "200"
        },
        {
          prop: "phone",
          label: "會員電話",
          width: "180"
        },
        // {
        //   prop: 'activitName',
        //   label: '活動名稱',
        //   width: '200'
        // },{
        //   prop: 'activitAgeLimit',
        //   label: '活動日期',
        //   width: '160'
        // },
        {
          prop: "createTime",
          label: "會員註冊時間",
          width: "200"
        },
        {
          prop: "updateTime",
          label: "會員更新時間",
          width: "200"
        },
        {
          prop: "reason",
          label: "原因",
          width: ""
        },
        {
          prop: "downTime",
          label: "禁用至",
          width: ""
        }
      ],
      currentPage: 1,
      total: 10,
      account: "",
      nickName: "",
      dialogVisible: false,
      blackType: "",
      blackStatus: "",
      uoloadModal: false,
      fileList: [],
      searchType: "1"
    };
  },
  // created() {
  //   let _this = this;
  //   _this.getblackList();
  // },
  activated() {
    let _this = this;
    _this.getblackList();
  },
  destroyed() {
    this.$message.closeAll();
  },
  methods: {
    // 获取黑名单列表
    getblackList() {
      let _this = this;
      let param = {
        pageNo: _this.currentPage,
        pageSize: 10
      };
      if (this.searchType == "1") {
        param = {
          ...param,
          email: _this.account === "" ? null : _this.account
        };
      } else if (this.searchType == "2") {
        param = {
          ...param,
          nickName: _this.account === "" ? null : _this.account
        };
      } else if (this.searchType == "3") {
        param = {
          ...param,
          realName: _this.account === "" ? null : _this.account
        };
      }
      !!this.blackType && (param.blackList = this.blackType);
      !!this.blackStatus && (param.blackStatus = this.blackStatus);
      _this
        .$post(
          "/request/blackMember/listBlack",
          param,
          _this.$GLOBAL.jsonConfig
        )
        .then(res => {
          if (res.code === "00000") {
            res.data.list.forEach(v => {
              v.activitAgeLimit = _this.$getTime(v.activitAgeLimit);
              v.createTime = _this.$getTime(v.createTime);
              v.updateTime = _this.$getTime(v.updateTime);
              v.downTime = _this.$getTime(v.downTime);
              v.phone = `+${v.area || 86} ${v.phone}`;
            });
            _this.blackList = res.data.list;
            _this.total = res.data.allRow;
          } else {
            _this.$propMessage(res.message, "error");
          }
        });
    },
    search() {
      let _this = this;
      // if (_this.account === '' && _this.nickName === '') {
      //   _this.dialogVisible = true;
      //   _this.$propMessage('請輸入搜索條件','error',function(){
      //     _this.dialogVisible = false;
      //   });
      //   return false;
      // }
      _this.$message.closeAll();
      _this.currentPage = 1;
      _this.getblackList();
    },
    // 重置
    reset() {
      this.account = "";
      this.nickName = "";
      this.currentPage = 1;
      this.blackStatus = "";
      this.blackType = "";
      this.getblackList();
    },
    // 分页
    handleCurrentChange(val) {
      let _this = this;
      _this.currentPage = val;
      _this.getblackList();
    },
    // 导出excel
    exportOrderExcel() {
      let _this = this;
      let url = "/request/blackMember/blackExportExcel";
      _this.$exportExcel(url, "GET", {}, "黑名單");
    },
    // 修改用戶信息
    toEditBlackUser(id, reason) {
      localStorage.setItem("blackReason", reason);
      this.$router.push(`/blackListDetails?id=${id}`);
    },
    // 解除黑名单
    removeBlackList(id, email, name) {
      let _this = this;
      let tipText = "";
      let successText = "";
      tipText = `<p>會員帳號：${email}</p><p>會員暱稱：${name}</p><p>是否解除該會員的【黑名單】狀態？</p>`;
      successText = "將用戶移出黑名單成功";
      _this
        .$confirm(tipText, "提示信息", {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "確認",
          cancelButtonText: "取消",
          center: true,
          closeOnClickModal: false
        })
        .then(() => {
          _this
            .$get(
              `/request/blackMember/removeBlackList/${id}`,
              _this.$GLOBAL.jsonConfig
            )
            .then(res => {
              _this.dialogVisible = true;
              if (res.code === "00000") {
                _this.$propMessage(successText, "success", function() {
                  _this.dialogVisible = false;
                  _this.getblackList();
                });
              } else {
                _this.$propMessage(res.message, "error", function() {
                  _this.dialogVisible = false;
                });
              }
            });
        })
        .catch(() => {});
    },
    downloadExcel() {
      window.open(
        "https://start.sanctuarytech.co/resource/excel/black_list_template.xlsx"
      );
    },
    uploadModal() {
      this.uoloadModal = true;
    },
    fileChange(file, fileList) {
      this.fileList = fileList;
    },
    // excel上传成功
    successExcel(res, file, fileList) {
      let _this = this;
      if (res.code === "00000") {
        _this.dialogVisible = true;
        _this.$propMessage("黑名單更新成功", "success", function() {
          _this.dialogVisible = false;
        });
        _this.getblackList();
        _this.$refs.excelUpload.clearFiles();
        this.uoloadModal = false;
      } else {
        _this.dialogVisible = true;
        _this.$propMessage(res.message, "error", function() {
          _this.dialogVisible = false;
        });
        _this.$refs.excelUpload.clearFiles();
      }
    },
    // excel上传失败
    errorExcel(err, file, fileList) {
      let _this = this;
      _this.$refs.excelUpload.clearFiles();
      _this.dialogVisible = true;
      _this.$propMessage(err.message + ",請重新上傳", "error", function() {
        _this.dialogVisible = false;
      });
    },
    submitupdate() {
      this.$refs.excelUpload.submit();
    }
  },
  components: {
    NavBar,
    DiaMess
  }
};
</script>

<style lang="less" scoped>
.content {
  .paddingContent {
    width: 100%;
    .ListMenu {
      display: flex;
    }
    .MenuBtnWrap {
      display: flex;
      justify-content: space-between;
      .MenuBtnWrapLeft {
        display: flex;
        align-items: center;
        .downloadExcel {
          margin-left: 11px;
          color: #6c3dea;
        }
      }
    }

    .tableWrap {
      width: 100%;
      height: calc(100% - 152px);
      overflow: auto;
      word-break: break-all;

      @media (max-width: 768px) {
        height: calc(100% - 92px);
      }

      @media (max-width: 420px) {
        height: calc(100% - 112px);
      }
    }
  }
  /deep/ .el-dialog {
    border-radius: 12px;
  }
  /deep/ .el-dialog__header {
    // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  }
  /deep/ .el-dialog__title {
    font-size: 0.16rem;
  }
  /deep/ .el-upload__text em {
    color: #6c3dea !important;
  }
  /deep/ .el-upload-dragger:hover {
    border-color: #6c3dea !important;
  }
  /deep/ .el-upload-dragger {
    width: 320px !important;
    border: 1px dashed #d9d9d9 !important;
  }
  .dialog {
    display: flex;
    justify-content: center;
    .el-upload__tip {
      color: #65676b;
    }
  }
  .btngroup {
    margin-top: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      text-align: center;
    }
  }
}
@media screen and (min-width: 769px) {
  .ListMenu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchForm {
      flex: 1;
      display: flex;
      justify-content: flex-start;
      .searchItem {
        margin-right: 0.2rem;
        margin-bottom: 0.2rem;
      }
    }
    .MenuBtnWrap {
      flex: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/blackList.vue